/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import Layout from '../Layout/Layout'
import { Link, NavLink, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import axios from 'axios';
import {RecaptchaVerifier, signInWithPhoneNumber} from 'firebase/auth'
import { useAuth } from '../../context/auth' 
import { auth } from './firebase';
import {Form, Spinner} from 'react-bootstrap';
import CountryPhone from '../CountryPhone';
import OtpInput from 'react-otp-input';
import PasswordStrengthBar from 'react-password-strength-bar';
import { addCartDataAfterLogin } from '../../Helper';
import IntlTelInputBox from './IntlTelInputBox';
import { getPriceCurrencyCode } from '../../Helper';
function Register() {
  const [searchParams] = useSearchParams(); 
  const currencyCode = getPriceCurrencyCode();
  const [validated, setValidated] = useState(false);
    const [showInputs, setShowInputs] = useState(false);
    const [otpStatus, setOtpStatus] = useState(false);
    const [otpTime, setOtpTime] = useState(40);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [phone, setPhone] = useState('');
    const [hasFilled, setHasFilled] = useState(false);
    const [otp, setOtp] = useState('');
    const [country, setCountry]=useState('+91');
    const[selectedCode, setSelectedCode] = useState('+91');
    
    const [fullPhone, setFullPhone] = useState('');
    const [lauth, setLauth] = useAuth();
    const [userType, setUserType] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState();
    const [password, setPassword] = useState('');
    const [cnfpassword, setCnfpassword] = useState('');
    const [register, setRegister] = useState(false)
    const location = useLocation();
    const navigate = useNavigate();
    const [recapGen, setRecapGen] = useState(false);
    const [errMsg, setErrMsg] = useState({});
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [verifying, setVerifying] = useState(false);
    const [passwordMatch, setPasswordMatch] = useState('');
    const [registerSuccess, setRegisterSuccess]=useState(false);

    const [autoMobile, setAutoMobile] = useState('');
    const validateMobileORemail = (value) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const mobileRegex = /^[6-9]\d{9}$/;
  
      if (emailRegex.test(value)) {
        return 1;
      } else if (mobileRegex.test(value)) {
        return 2;
      } else {
        return 0;
      }
    };
    
    
    useEffect(() => {
      const urlQueryStringdata = searchParams.get("signup");  
      if (!urlQueryStringdata) return;  
      const validationResult = validateMobileORemail(urlQueryStringdata);      
      if (validationResult === 1) {
        setEmail(urlQueryStringdata);
      } else if (validationResult === 2) {
        setAutoMobile(urlQueryStringdata);
      }
    }, [searchParams]);

    useEffect(() => {
      let isAuth = JSON.parse(localStorage.getItem('auth'));
      //console.log(isAuth)
      if(isAuth && isAuth !== null) {
          navigate("/");
      }
      //eslint-disable-next-line
  }, []);
  
  useEffect(() => {
    if(password!=='' && password.length>=8 && password===cnfpassword){
      setPasswordMatch(' password-matched')
    }else{
      setPasswordMatch('')
    }
  }, [password,cnfpassword]);

    useEffect(() => {
        if (otpTime > 0) {
          const intervalId = setInterval(() => {
            setOtpTime(otpTime - 1);
          }, 1000);
          return () => clearInterval(intervalId);
        }
      }, [otpTime]);
    
      useEffect(() => {
        if(otp.length===6){
          verifyOtp();
          setVerifying(true)
        }
      }, [otp]);
      
      const resendOTP = async (event) => {
        setLoading(true)
        setErrMsg({});
        setOtp('')
        if (isButtonDisabled) {
          return;
        }
        setIsButtonDisabled(true);
        const userVal = await registerResendOTP(fullPhone,email);
        if(userVal?.status){
          setLoading(false) 
          setErrMsg({cls:'alert alert-success text-center', msg:"OTP resent successfully."});
          setOtpTime(40);
          setIsButtonDisabled(false);
        }else{
          setLoading(false)
          setErrMsg({cls:'alert alert-danger text-center', msg:"OTP not send please try again later!"});
        }
      };
     
      const generateRecaptcha = () => {
        if(!recapGen){
          window.recaptchaVerifier = new RecaptchaVerifier('recaptcha', {
            'size': 'invisible',
            'callback': (response) => {
              // reCAPTCHA solved, allow signInWithPhoneNumber.
              // ...
            }
          }, auth);
          setLoading(false)
        }
      }
    
      const checkUserExist = async (fullPhone, email)=>{
        try {
            let {data} = await axios.post(`${process.env.REACT_APP_API_URL}/auth/registerOtp`,{phone:fullPhone,email:email});
            //console.log(data); return false;
            if(data?.status){
                return data;
            }else{
              return data;
            }
        } catch (error) {
            console.log(error)
        }
      }

      const checkOTPverify = async (fullPhone, email, otp)=>{
        try {
            let {data} = await axios.post(`${process.env.REACT_APP_API_URL}/auth/registerVerifyOtp`,{otp:otp,phone:fullPhone,email:email});
            if(data?.status){
                return data;
            }else if(!data?.status){
                setErrMsg({cls:'alert alert-danger', msg:"Invalid OTP."});
                //return 'guest';
            }
        } catch (error) {
            console.log(error)
        }
      }

      const registerResendOTP = async (fullPhone,email)=>{
        try {
            let {data} = await axios.post(`${process.env.REACT_APP_API_URL}/auth/registerResendOTP`,{phone:fullPhone,email:email});
            if(data?.status){
                return data;
            }else if(!data?.status){
                setErrMsg({cls:'alert alert-danger', msg:"We cannot find an account with this mobile number."});
                return 'guest';
            }
        } catch (error) {
            console.log(error)
        }
      }

      const handleSend = async (event) => {
        setLoading(true)
        setSubmitting(true)        
        setErrMsg({});
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
          event.stopPropagation();
          setLoading(false)
          setSubmitting(false)
        }
        setValidated(true);
        if(form.checkValidity()===true) {
          setFullPhone(fullPhone);
          setEmail(email);
          const userVal = await checkUserExist(fullPhone, email);
          setUserType(userVal);
          if(userVal?.status===false){
            setErrMsg({cls:'alert alert-danger text-center', msg:userVal?.message});
            setLoading(false)
            setSubmitting(false)
              return false;
          }
          setErrMsg({cls:'alert alert-warning text-center otp-sending', msg:"Sending OTP..."});
          setOtpTime(40);
          setHasFilled(true);
          generateRecaptcha();
          setRecapGen(true);
          setLoading(true)
          setErrMsg({cls:'alert alert-success text-center', msg:"OTP sent successfully."});
          setLoading(false)
          setSubmitting(false)
          setOtpStatus(true);
        }
      }
      
      const verifyOtp = async () => {
        setLoading(true)
        setVerifying(true)
        setErrMsg({});
        setValidated(true);
            if (otp.length === 6) {
              const checkOTPverifyData = await checkOTPverify(fullPhone, email, otp);
              if(checkOTPverifyData.status){
                setErrMsg({cls:'alert alert-success text-center', msg:"OTP verified successfully."});
                setShowInputs(true)
                setOtpStatus(false); 
                setLoading(false)
                setVerifying(false)
              }else{
                setLoading(false)
                setErrMsg({cls:'alert alert-danger text-center', msg:checkOTPverifyData?.message});
                setVerifying(false)
              }
            }else{
                setLoading(false)
                setErrMsg({cls:'alert alert-danger text-center', msg:"OTP length must be 6 digit."});
                setVerifying(false)
            }
        
      }

      const handleRegister = async(event)=>{
        setLoading(true)
        setSubmitting(true) 
        setErrMsg({});
        try {
            const form = event.currentTarget;
            //console.log(form)
            event.preventDefault();
            if (form.checkValidity() === false) {
              event.stopPropagation();
              setLoading(false)
              setSubmitting(false)
            }
            setValidated(true);
            if(firstName==='' || lastName==='' || email==='' || password==='' || cnfpassword===''){
              setErrMsg({cls:'alert alert-danger text-center', msg:"Please fill all required fielsd."});
              setLoading(false)
              setSubmitting(false)
              return;
            }
            if(password.length<8){
              setLoading(false)
              setSubmitting(false)
              return;
            }
            
            if(form.checkValidity()===true) { 

              const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
              if(!strongRegex.test(password)) {
                setLoading(false)
                setSubmitting(false)
                setErrMsg({cls:'alert alert-danger text-center', msg:"Password should contain at least one uppercase letter, one lowercase letter, one digit, and one special character!"});
                return;
              }

              if(password!==cnfpassword){
                setLoading(false)
                setSubmitting(false)
                setErrMsg({cls:'alert alert-danger text-center', msg:"The passwords do not match. Please enter again."});
              }else{
                let {data} = await axios.post(`${process.env.REACT_APP_API_URL}/auth/register`,{first_name:firstName,last_name:lastName,email:email,password:password,c_code:'+00',phone:fullPhone});
                //console.log(data)
                
                if(data?.status){
                  setLauth({
                      ...lauth,
                      user:data.results,
                      token:data.token
                  })
                  localStorage.setItem('auth',JSON.stringify({
                                                              ...lauth,
                                                              user:data.results,
                                                              token:data.token
                                                          }))
                  //FB pixel code: CompleteRegistration
                  if (typeof window !== "undefined") {
                    if (window.fbq != null) { 
                      window.fbq('track', 'CompleteRegistration', {
                        content_name: firstName,
                        status: 'completed',
                        currency: 'INR'
            
                    });
                    }
                  }

                  addCartDataAfterLogin();
                  setRegisterSuccess(true)
                  setTimeout(()=>{
                    navigate(location.state || "/"); 
                  }, 5000);
                  setLoading(false)
                  setSubmitting(false)
                   
                }else if(!data.status){
                  //console.log(data);
                  setLoading(false)
                  setSubmitting(false)
                  let errM = data?.message[0]?.message;
                  setErrMsg({cls:'alert alert-danger text-center', msg:errM});
                  return false;
                }
              }
              
            } 
        } catch (error) {
            setLoading(false)
            setSubmitting(false)
            console.log(error)
        }
      }

const [intelValid,setIntelValid] = useState('');
const handleIntel = (dv)=>{
  setIntelValid(dv)
}

  return (    
    <Layout title="Register | Chaashni by Maansi & Ketan" description="Chaashni by Maansi & Ketan" >
        <div className="site-content-wrap login">
            <div className='loginbox'>
                <h2>LOGIN / SIGN UP</h2>
                <div className='login-inner'>
                    <div className='login-tab'>
                        <ul>                            
                            <li><NavLink className={({ isActive }) => isActive ? "active nav-link" : "nav-link"} to="/login">LOGIN</NavLink></li>
                            <li><NavLink className={({ isActive }) => isActive ? "active nav-link" : "nav-link"} to="/register">CREATE A NEW ACCOUNT</NavLink></li>
                        </ul>
                    </div>
                    <div className={`login-content ${loading?'loading-old':''}`}>
                    <div className='app__container'>
                   
                            {!otpStatus?
                                !showInputs? <div>
                                  <Form noValidate validated={validated} onSubmit={handleSend}>   
                                    {errMsg.cls? <div className={errMsg.cls}>{errMsg.msg}</div>:'' }
                                    {/*
                                      <div className='login-data mobile-field'> 
                                        <div className='country-field'>
                                        <CountryPhone code={country} selectedCode={setSelectedCode}/>
                                        </div>
                                        <div className='ph-field'>
                                            <input type="text" placeholder="Your Mobile Number" className='form-control input-text' required  value={phone} onChange={(e)=>setPhone(e.target.value)} />
                                        </div>
                                      </div>
                                  */}
                                    <div className='login-data mobile-field'>
                                      <IntlTelInputBox setFullPhone={setFullPhone} selectedPhone={autoMobile} handleIntel={handleIntel}/>
                                    </div>
                                    <div className='login-data mobile-field'>
                                    <input type="email" placeholder="Enter Email" className='form-control input-text register-form-control' value={email} onChange={(e)=>setEmail(e.target.value)} required />
                                    </div>

                                    <div className='login-data checkbox-field'><input className='form-check-input' value={1} type='checkbox' required /> <span>I agree with</span>  <Link to="/pages/terms-conditions" target='_blank' style={{color:"#e61c44"}}>Terms & Conditions</Link> and <Link to="/pages/privacy-policy" target='_blank' style={{color:"#e61c44"}}>Privacy Policy</Link></div>
                                    <div className='login-data'><button type="submit" className="btn register-btn" style={{width:"170px"}} disabled={!intelValid?true:false}>{submitting?'SENDING...':'REGISTER'}</button></div>
                                    </Form>
                                    </div>:''
                                
                            :''}

                            {otpStatus? <div>
                                        <Form noValidate validated={validated} onSubmit={(event)=>{ event.preventDefault(); verifyOtp() }}>
                                            {errMsg.cls? <div className={errMsg.cls}>{errMsg.msg}</div>:'' }      
                                              {/*
                                                <div className='login-data mobile-field'> 
                                                    <div className='country-field'>
                                                      <CountryPhone code={country} selectedCode={setSelectedCode}/>
                                                    </div>
                                                    <div className='ph-field'>
                                                        <input type="text" placeholder="Your Mobile Number" className='form-control input-text' readOnly value={phone} onChange={(e)=>setPhone(e.target.value)} required="" />
                                                    </div>
                                                </div>
                                            */}
                                                <div className={`login-data mobile-field${otpStatus?' otp-send':''}`}>
                                                  <IntlTelInputBox setFullPhone={setFullPhone} selectedPhone={fullPhone} handleIntel={handleIntel}/>
                                                </div>
                                                <div className='login-data mobile-field otp-field'>
                                                <div className='country-field'></div>
                                                <div className='otp-field new-otp-field'  style={{marginTop:"0"}}>

                                                <div className='login-data mobile-field otp-field'>
                                                <input type="email" placeholder="Enter Email" readOnly className='form-control input-text register-form-control' value={email} onChange={(e)=>setEmail(e.target.value)} required />
                                                </div>
                                                    
                                              <div className='otp-field-box'>
                                                <span className='otp-text login-data'>Please enter the OTP here.</span>
                                                <OtpInput shouldAutoFocus={true} skipDefaultStyles={true} inputStyle={'otp-input'}  value={otp}  onChange={setOtp}  numInputs={6}  renderInput={(props) => <input {...props} />} />
                                              </div>
                                                    <button type="submit" className="btn" disabled={verifying?true:false}>{verifying?'Verifying...':'Verify OTP'}</button>
                                                   <div className='new-resend-otp'> <button type='button' onClick={() => resendOTP()} disabled={otpTime > 0}><span>{isButtonDisabled ? "Sending" : "Resend OTP"}</span></button>
                                                    {otpTime > 0 && <div className='red-text'>({otpTime})</div>}</div>
                                                    </div>
                                                </div>
                                        </Form>
                                        </div>:''
                            }

                                {showInputs? <div>

                                  {registerSuccess?(
                                    <div className='login-data redirecting-now'>
                                      <div className='alert alert-success'>Registration successful.</div>
                                      <div className='redirecting-text'>Redirecting now... <Spinner animation="border" /></div>
                                    </div>
                                  ):''}

                                  <Form noValidate validated={validated} onSubmit={handleRegister} className={`form-data${registerSuccess?' form-hide':''}`}>
                                    {errMsg.cls? <div className={errMsg.cls}>{errMsg.msg}</div>:'' } 
                                    {/*
                                      <div className='login-data mobile-field'>
                                        <div className='country-field'>
                                        <CountryPhone code={country} selectedCode={setSelectedCode}/>
                                        </div>
                                        <div className='ph-field'>
                                            <input type="text" placeholder="Your Mobile Number" className='form-control input-text' readOnly value={phone} onChange={(e)=>setPhone(e.target.value)} required />
                                        </div>
                                    </div>
                                    */}
                                <div className='login-data mobile-field'><IntlTelInputBox setFullPhone={setFullPhone} selectedPhone={fullPhone} handleIntel={handleIntel}/></div>
                                <div className='login-data'><input type="text" placeholder="First Name" required className='form-control input-text' value={firstName} onChange={(e)=>setFirstName(e.target.value)} /></div>
                                <div className='login-data'><input type="text" placeholder="Last Name" className='form-control input-text' value={lastName} onChange={(e)=>setLastName(e.target.value)} required /></div>
                                <div className='login-data'><input type="email" placeholder="Enter Email" className='form-control input-text' readOnly value={email} onChange={(e)=>setEmail(e.target.value)} required /></div>                                                <div className='login-data'>
                                <input type="password" minLength={8} placeholder="Password" className='form-control input-text' value={password} onChange={(e)=>{ setPassword(e.target.value); }} 
                                                pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*]).{8,}"
                                                isInvalid={
                                                  validated &&
                                                  !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(password)
                                                }
                                                required />

                                                <div className="password-strength">
                                                <PasswordStrengthBar password={password} minLength={8} shortScoreWord={'Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).'} scoreWords={['Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).', 'Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).', 'Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).', 'Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).','Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).']}/>
                                                </div>
                                                </div>
                                                <div className='login-data'>                                                
                                                <input type="password" placeholder="Confirm Password" minLength={8} className={`form-control input-text${passwordMatch}`}  value={cnfpassword} onChange={(e)=>{setCnfpassword(e.target.value);}} required />
                                                </div>
                                                <div className='login-data checkbox-field'><input type='checkbox' className='form-check-input' required="true" /> <span>I agree with</span>  <Link to="/pages/terms-conditions" style={{color:"#e61c44"}}>Terms & Conditions</Link> and <Link to="/pages/privacy-policy" style={{color:"#e61c44"}}>Privacy Policy</Link></div>
                                                <div className='login-data'><button type="submit" className="btn" style={{width:"170px"}} disabled={submitting?true:false}>{submitting?'SUBMITTING...':'REGISTER'}</button></div>
                                    </Form>              
                                        </div>:''
                                }
                        <div id="recaptcha"></div>                        
                        <div className={`login-data${registerSuccess?' form-hide':''}`} style={{margin:"15px 0 0"}}>Already a Member? Click Here to <Link to="/login" style={{fontWeight:"bold", color:"#000", textDecoration:"none"}}>LOGIN</Link></div>
                        
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
  )
}

export default Register
